import * as React from 'react';
import { AdresseTiersReadNoteGroupTimestampableBlameambleGroup } from '@europrocurement/l2d-domain/openApi/ApiTiers';
import { formatPrescriberAddress } from '@europrocurement/l2d-utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button, Typography } from '@mui/material';
import { TextIcon } from '../../atoms';

export type AddressLinkProps = {
    address: AdresseTiersReadNoteGroupTimestampableBlameambleGroup | string;
    icon?: IconProp;
    type?: 'text' | 'button';
};

export const AddressLink: React.FunctionComponent<AddressLinkProps> = function (props) {
    const { address, icon, type = 'text' } = props;
    const [onHover, setHover] = React.useState<boolean>(false);

    const longAddress =
        typeof address === 'string' ? address : formatPrescriberAddress(address, 'long');
    const shortAddress =
        typeof address === 'string' ? address : formatPrescriberAddress(address, 'short');

    const openGoogleMapTab = () => {
        const mapQueryUrl = `https://www.google.com/maps/?q=${longAddress}`;
        window.open(mapQueryUrl, '_blank');
    };

    const locationIcon: IconProp = ['fasl', 'location-dot'];

    const hoverProps = {
        onMouseEnter: () => setHover(true),
        onMouseLeave: () => setHover(false),
    };

    if (type === 'text') {
        const pointerOnHover = {
            cursor: onHover ? 'pointer' : '',
        };
        return (
            <Typography
                {...hoverProps}
                sx={pointerOnHover}
                onClick={openGoogleMapTab}
            >
                {shortAddress}
            </Typography>
        );
    }

    const subtitleElementStyle = {
        display: 'flex',
        opacity: 0.6,
        fontSize: '12px',
        fontWeight: '300',
        alignItems: 'center',
        marginRight: '10px',
        color: 'inherit',
    };

    return (
        <Button
            data-testid="AddressLink-test-id"
            onClick={openGoogleMapTab}
            sx={subtitleElementStyle}
        >
            <TextIcon
                icon={{ props: { icon: icon || locationIcon } }}
                gap="4px"
            >
                <Typography>{shortAddress}</Typography>
            </TextIcon>
        </Button>
    );
};
